export interface YoutubeChannel {
  id: string;
  channel: string;
  title: string;
  description: string;
  category: 'Comédie' | 'Actu' | 'Vlog' | 'Musique' | 'Interview';
  thumbnail_url: string;
  subscribers: number;
  video_count: number;
  link_url: string;
}

export const youtubeChannels: YoutubeChannel[] = [
  {
    id: 'yt-1',
    channel: 'Les Rires du Togo',
    title: 'Sketch : la vie de bureau à Lomé',
    description: 'Une parodie hilarante des galères du quotidien au bureau.',
    category: 'Comédie',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20comedy%20group%20performing%20a%20hilarious%20sketch%20in%20a%20colorful%20living%20room%20set%20expressive%20acting%20bright%20studio%20lighting%20professional%20YouTube%20comedy%20video%20thumbnail%20warm%20vibrant%20colors%20high%20detail&width=1280&height=720&seq=youtube-1&orientation=landscape',
    subscribers: 458000,
    video_count: 312,
    link_url: 'https://www.youtube.com/results?search_query=sketch+comique+togolais',
  },
  {
    id: 'yt-2',
    channel: 'Togo 24 Actu',
    title: 'Les infos de la semaine en 10 minutes',
    description: 'Le résumé des actualités marquantes du Togo et de la sous-région.',
    category: 'Actu',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Young%20African%20news%20reporter%20presenting%20current%20events%20in%20a%20modern%20studio%20with%20warm%20lighting%20professional%20setup%20YouTube%20news%20video%20thumbnail%20rich%20warm%20tones%20high%20detail&width=1280&height=720&seq=youtube-2&orientation=landscape',
    subscribers: 892000,
    video_count: 1840,
    link_url: 'https://www.youtube.com/results?search_query=actualite+togo',
  },
  {
    id: 'yt-3',
    channel: 'Mawu Vlogs',
    title: 'Une journée au grand marché de Lomé',
    description: 'Je vous emmène découvrir les couleurs et saveurs du marché.',
    category: 'Vlog',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20vlogger%20walking%20through%20a%20vibrant%20market%20in%20Lome%20Togo%20holding%20a%20camera%20sunny%20day%20colorful%20stalls%20professional%20YouTube%20vlog%20video%20thumbnail%20warm%20vibrant%20tones%20high%20detail&width=1280&height=720&seq=youtube-3&orientation=landscape',
    subscribers: 234000,
    video_count: 156,
    link_url: 'https://www.youtube.com/results?search_query=vlog+togo',
  },
  {
    id: 'yt-4',
    channel: 'Comédie 228',
    title: 'Quand ta belle-mère débarque à l&apos;improviste',
    description: 'Le sketch culte qui a fait des millions de vues.',
    category: 'Comédie',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Two%20African%20comedians%20in%20traditional%20and%20modern%20clothes%20laughing%20during%20a%20funny%20skit%20colorful%20background%20bright%20lighting%20YouTube%20comedy%20thumbnail%20warm%20tones%20high%20detail&width=1280&height=720&seq=youtube-4&orientation=landscape',
    subscribers: 1200000,
    video_count: 540,
    link_url: 'https://www.youtube.com/results?search_query=comedie+togolaise',
  },
  {
    id: 'yt-5',
    channel: 'Studio Afrique',
    title: 'Interview exclusive : Santrinos Raphael',
    description: 'La star de l&apos;AfroRnB se confie sur son parcours.',
    category: 'Interview',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20talk%20show%20host%20interviewing%20a%20guest%20on%20a%20warm%20studio%20set%20with%20soft%20lighting%20professional%20YouTube%20interview%20thumbnail%20rich%20warm%20colors%20high%20detail&width=1280&height=720&seq=youtube-5&orientation=landscape',
    subscribers: 645000,
    video_count: 289,
    link_url: 'https://www.youtube.com/results?search_query=interview+artiste+togolais',
  },
  {
    id: 'yt-6',
    channel: 'Kara Créations',
    title: 'Dans les coulisses de mon dernier clip',
    description: 'Les secrets de fabrication d&apos;un clip afro réussi.',
    category: 'Vlog',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=African%20content%20creator%20filming%20behind%20the%20scenes%20with%20camera%20equipment%20in%20a%20creative%20studio%20warm%20lighting%20YouTube%20BTS%20video%20thumbnail%20warm%20tones%20high%20detail&width=1280&height=720&seq=youtube-6&orientation=landscape',
    subscribers: 187000,
    video_count: 98,
    link_url: 'https://www.youtube.com/results?search_query=coulisses+clip+afro',
  },
  {
    id: 'yt-7',
    channel: 'Voklia Jokes',
    title: 'LELO TALK : le talk-show qui fait rire tout Lomé',
    description: 'Humour, débats et sketchs : la référence de la comédie togolaise sur YouTube.',
    category: 'Comédie',
    thumbnail_url: 'https://img.youtube.com/vi/rwTwsOeHheI/hqdefault.jpg',
    subscribers: 124000,
    video_count: 340,
    link_url: 'https://www.youtube.com/@vokliajokes',
  },
  {
    id: 'yt-8',
    channel: 'Télévision Togolaise (TVT)',
    title: 'Le journal de 20h — l\u2019actualité du Togo',
    description: 'La chaîne nationale officielle du Togo : infos, culture et découvertes.',
    category: 'Actu',
    thumbnail_url: 'https://img.youtube.com/vi/Mdu413THmSk/hqdefault.jpg',
    subscribers: 163000,
    video_count: 7600,
    link_url: 'https://www.youtube.com/@TelevisionTogolaise',
  },
  {
    id: 'yt-9',
    channel: 'Toofan Officiel',
    title: 'GWETA (Official HD) — le tube qui a fait danser le monde',
    description: 'Le duo togolais le plus célèbre (Barabas & Master Just), 22M de vues.',
    category: 'Musique',
    thumbnail_url: 'https://img.youtube.com/vi/RJ2e_V_2XAk/hqdefault.jpg',
    subscribers: 1200000,
    video_count: 180,
    link_url: 'https://www.youtube.com/@ToofanOfficiel',
  },
  {
    id: 'yt-10',
    channel: 'Santrinos Raphael',
    title: 'Monica ft Stonebwoy — le duo qui a marqué l\u2019AfroRnB',
    description: 'La star de l\u2019AfroRnB togolais et ses millions de vues.',
    category: 'Musique',
    thumbnail_url: 'https://img.youtube.com/vi/Z8g2Rw6BbSQ/hqdefault.jpg',
    subscribers: 890000,
    video_count: 210,
    link_url: 'https://www.youtube.com/@SantrinosRaphael',
  },
  {
    id: 'yt-11',
    channel: 'Burna Boy',
    title: 'Gbona — l\u2019afro-fusion qui a conquis le monde',
    description: 'La superstar nigériane et son tube planétaire, multi-récompensé.',
    category: 'Musique',
    thumbnail_url: 'https://img.youtube.com/vi/h7WfPHHXCAY/hqdefault.jpg',
    subscribers: 5400000,
    video_count: 420,
    link_url: 'https://www.youtube.com/@BurnaBoy',
  },
  {
    id: 'yt-12',
    channel: 'Davido',
    title: 'Yaya (feat. Aya Nakamura) — le duo afropop mondial',
    description: 'Davido et Aya Nakamura réunis pour un hit incontournable.',
    category: 'Musique',
    thumbnail_url: 'https://img.youtube.com/vi/_b12oPrxprM/hqdefault.jpg',
    subscribers: 5800000,
    video_count: 360,
    link_url: 'https://www.youtube.com/@Davido',
  },
  {
    id: 'yt-13',
    channel: 'Fally Ipupa',
    title: 'La rumba congolaise à l\u2019honneur',
    description: 'La légende congolaise et ses tubes qui font danser toute l\u2019Afrique francophone.',
    category: 'Musique',
    thumbnail_url:
      'https://readdy.ai/api/search-image?query=Congolese%20rumba%20music%20concert%20stage%20with%20a%20charismatic%20African%20singer%20performing%20under%20warm%20golden%20spotlights%20elegant%20dancers%20colorful%20lights%20professional%20YouTube%20music%20video%20thumbnail%20rich%20warm%20tones%20high%20detail&width=1280&height=720&seq=youtube-13&orientation=landscape',
    subscribers: 3200000,
    video_count: 280,
    link_url: 'https://www.youtube.com/@FallyIpupa',
  },
];